const MODULE_NAME = "SMS/";
export const PAGINATION = {
  page: 1,
  size: 20
};

export const BROWSE_TRIPOD = `${MODULE_NAME}/TRIPODS`;
